<template>
  <v-tooltip :text="`Details for ${props.descriptiveWord} '${item.name}'`" location="top">
    <template v-slot:activator="{ props }">
      <v-btn
          v-bind="props"
          class="mx-1"
          size="small"
          rounded
          flat
          height="35px"
          min-width="35px"
          max-width="35px"
          color="blue-darken-4"
          @click.prevent="viewItem(false)"
          @auxclick.prevent="viewItem(true)"
      ><i class="fas fa-eye" /></v-btn>
    </template>
  </v-tooltip>
</template>

<script setup>
import {router} from "@inertiajs/vue3";

const props = defineProps({

  /**
   * Used for the purpose of the tooltip. It's usually a literal like 'Project' or 'KPI'.
   */
  descriptiveWord: {
    type: String,
    required: true
  },

  /**
   * Usually, this prop refers to a database object. A `Project`, a `KPI`, a `PSI`; stuff like that.
   * In this specific component, it's important that this object has `id` and `name` attributes.
   */
  item: {
    type: Object,
    required: true,
  },

  /**
   * The targeted route of the button. When pressed, the button will send a GET request to this route.
   */
  route: {
    type: String,
    required: true
  }
});

function viewItem(openInNewWindow) {

  if (openInNewWindow)
    window.open(props.route, '_blank');
  else
    router.get(props.route);
}
</script>


